import { Heading } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'
import { useRouter } from 'next/router'
import React from 'react'
import { Head } from '../../../src/component'
import { CheckoutPage } from '../../../src/model'
import { useCheckoutSizes } from '../../../src/utils/responsive'
import { EditShippingAddressForm } from '../../../src/component/EditShippingAddressForm/EditShippingAddressForm'
import { TrackPageViewed } from '../../../src/integrations/monitoring'
import { getNumOrString } from '@afterpay/utils'

export const EditShippingAddressPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const { headingSize } = useCheckoutSizes()
  const router = useRouter()
  const { id } = router.query
  // Array check to satisfy type only.
  const addressId = Array.isArray(id) ? id[0] : id
  const shippingAddressId = getNumOrString(addressId)

  const pageTitle = `${t('shippingAddress:editShippingAddress')} | ${t('common:brandName')}`

  return (
    <>
      <Head title={pageTitle} />
      <Heading size={headingSize}>{t('shippingAddress:editShippingAddress')}</Heading>
      <EditShippingAddressForm id={shippingAddressId} />
      <TrackPageViewed />
    </>
  )
}
